import React from 'react';

import { ACCORDION_INITIAL_ITEMS_COUNT } from '../../../../ahm-constants/ui';
import { BlockType } from '../../../../types/sanityInternal';
import { ImageType } from '../../../../types/image';
import { MappedQuestion } from '../../../../types/question';
import AccordionSection from '../../../../components/sections/accordion-section';
import questionsHeroImage from '../../../../images/questions-hero.svg';
import WrappedSection from '../../../../components/sections/wrapped-section';

type CommonQuestionsProps = {
  insuranceType: string;
  items: MappedQuestion[];
  isTwoColumn: boolean;
  title?: string;
  summary?: BlockType[];
  image?: ImageType;
};

const CommonQuestions = ({ insuranceType, isTwoColumn, title, summary, image, ...props }: CommonQuestionsProps) => {
  const accordionId = `${insuranceType}-insurance-common-questions${isTwoColumn ? '-two-column' : ''}`;
  return (
    <WrappedSection withWide={isTwoColumn} withBorder>
      <AccordionSection
        {...props}
        accordionId={accordionId}
        initialVisible={ACCORDION_INITIAL_ITEMS_COUNT}
        image={
          image || {
            alt: 'Billboard stating "Got questions? We’ve got the answers"',
            src: questionsHeroImage.src,
          }
        }
        isTwoColumn={isTwoColumn}
        title={title || 'Common questions'}
        withBorder={false}
        summary={summary}
      />
    </WrappedSection>
  );
};

export default CommonQuestions;
